import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { colorPalette } from '@repo/mui-config/color-palette';

const titleProps = {
  fontSize: { xs: 24, sm: 32, md: 48, lg: 32, xl: 38 },
  fontWeight: 'bold',
  lineHeight: {
    xs: '30px',
    sm: '42px',
    md: '53px',
    lg: '42px',
    xl: '43px',
  },
};

export function LiberisAmountFormTitle() {
  const { t } = useTranslation();

  return (
    <>
      <Typography {...titleProps}>
        {t('welcomePage.loanApplicationPossible.liberis.amountForm.title.newPossibilities')}
      </Typography>
      <Typography
        color={colorPalette.primary.main}
        sx={{
          display: 'inline',
        }}
        {...titleProps}
      >
        {t('welcomePage.loanApplicationPossible.liberis.amountForm.title.financing')}
      </Typography>{' '}
      <Typography
        {...titleProps}
        sx={{
          display: 'inline',
          marginLeft: { sm: 1, md: 0 },
        }}
      >
        {t('welcomePage.loanApplicationPossible.liberis.amountForm.title.forYourCompany')}
      </Typography>
    </>
  );
}
